/**
 * 投诉请求接口
 * @author 王振宇
 * @since 2022-07-21
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_FEEDBACK_PAGE_LIST: function GET_FEEDBACK_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/feedback/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_FEEDBACK_LIST: function GET_FEEDBACK_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/feedback/getList',
        method: 'get',
        params: data
      });
    },
    GET_FEEDBACK_INFO: function GET_FEEDBACK_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/feedback/info',
        method: 'get',
        params: data
      });
    },
    SAVE_FEEDBACK: function SAVE_FEEDBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/feedback/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_FEEDBACK: function UPDATE_FEEDBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/feedback/update',
        method: 'put',
        data: data
      });
    },
    DELETE_FEEDBACK: function DELETE_FEEDBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/feedback/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_FEEDBACK: function DELETE_BATCH_FEEDBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/feedback/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});